<script setup lang="ts">
import Modal from "@/components/modal/modal.vue";
</script>
<template>
    <!-- TODO переводы -->
    <Modal>
        <template #header>
            <p class="tiw__h2">Wstępna cena</p>
        </template>
    </Modal>
</template>
